import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterLink } from "@angular/router";
import { DropdownModule } from "primeng-v17/dropdown";
import { TagModule } from "primeng-v17/tag";
import { AppDateTimePipe } from "../../shared/pipes/date.pipe";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { KpiCarouselViewComponent } from "./kpi-carousel-view/kpi-carousel-view.component";
import { KpiGridViewComponent } from "./kpi-grid-view/kpi-grid-view.component";
import { NewUiKpiComponent } from "./new-ui-kpi.component";

@Component({
  selector: "app-kpi",
  templateUrl: "./kpi.component.html",
  styleUrl: "./kpi.component.scss",
  imports: [
    TranslateDirective,
    RouterLink,
    KpiCarouselViewComponent,
    KpiGridViewComponent,
    AppDateTimePipe,
    DropdownModule,
    TagModule,
    FormsModule,
  ],
})
export class KpiComponent extends NewUiKpiComponent {}
